import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

sortSelectStyles.select = {
    cssOverrides: {
        formField: css`
            > label {
                padding: 0 10px 0 10px;
                font-style: italic;
                font-weight: bold;
                font-size 14px;
                width: auto;
            }
            align-items: center;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                ]);
            }}
        `,
        formInputWrapper: css`
            width: auto;
            > select {
                font-size: 14px !important;
                width: calc(100% + 18px) !important;
            }
            > span {
                right: -18px !important;
            }
        `,
    },
};
